<ng-container *ngIf="showShell">
  <!-- Mobile FAB -->
  <button *ngIf="showFab" type="button" class="coach-fab" (click)="toggle()"
    [attr.aria-label]="open ? 'Close messages' : 'Open messages'"
    [attr.aria-expanded]="open">
    <i class="bi" [class.bi-chat-dots-fill]="!open" [class.bi-x-lg]="open"></i>
    <span class="badge" *ngIf="!open && unread > 0">{{ unread > 99 ? '99+' : unread }}</span>
  </button>

  <!-- Desktop collapsed strip -->
  <button *ngIf="showDesktopDock && collapsed" type="button" class="coach-strip" (click)="toggle()"
    aria-label="Open coach messages">
    <i class="bi bi-chat-dots-fill"></i>
    <span class="strip-label">Messages</span>
    <span class="badge" *ngIf="unread > 0">{{ unread > 99 ? '99+' : unread }}</span>
  </button>

  <!-- Panel: desktop dock or mobile popup -->
  <div class="coach-panel" *ngIf="showPanel"
    [class.mobile]="isMobile" [class.desktop]="!isMobile"
    role="dialog" aria-label="Messages with your coaches">
    <header class="drawer-header">
      <ng-container *ngIf="!active; else threadHeader">
        <div>
          <h2>Messages</h2>
          <p>Your coaches</p>
        </div>
        <div class="header-actions">
          <button type="button" class="icon-btn" (click)="refresh()" aria-label="Refresh" title="Refresh">
            <i class="bi bi-arrow-clockwise" [class.spin]="refreshing"></i>
          </button>
          <button type="button" class="icon-btn" (click)="close()" [attr.aria-label]="isMobile ? 'Close' : 'Collapse'">
            <i class="bi" [class.bi-x-lg]="isMobile" [class.bi-chevron-double-right]="!isMobile"></i>
          </button>
        </div>
      </ng-container>
      <ng-template #threadHeader>
        <button type="button" class="icon-btn" (click)="backToList()" aria-label="Back">
          <i class="bi bi-chevron-left"></i>
        </button>
        <div class="peer">
          <span class="avatar">
            <img *ngIf="active?.coach?.picture_url" [src]="active!.coach!.picture_url" alt="" />
            <span *ngIf="!active?.coach?.picture_url">{{ initials(active?.coach?.name) }}</span>
          </span>
          <div>
            <h2>{{ active?.coach?.name }}</h2>
            <p>{{ active?.product_line_label }}</p>
          </div>
        </div>
        <div class="header-actions">
          <button type="button" class="icon-btn" (click)="refresh()" aria-label="Refresh" title="Refresh">
            <i class="bi bi-arrow-clockwise" [class.spin]="refreshing"></i>
          </button>
          <button type="button" class="icon-btn" (click)="close()" [attr.aria-label]="isMobile ? 'Close' : 'Collapse'">
            <i class="bi" [class.bi-x-lg]="isMobile" [class.bi-chevron-double-right]="!isMobile"></i>
          </button>
        </div>
      </ng-template>
    </header>

    <div class="coach-list" *ngIf="!active">
      <button type="button" class="coach-row" *ngFor="let c of coaches"
        [disabled]="!c.thread_id" (click)="openThread(c)">
        <span class="avatar">
          <ng-container *ngIf="c.coach; else pendingAvatar">
            <img *ngIf="c.coach.picture_url" [src]="c.coach.picture_url" alt="" />
            <span *ngIf="!c.coach.picture_url">{{ initials(c.coach.name) }}</span>
          </ng-container>
          <ng-template #pendingAvatar><i class="bi bi-hourglass-split"></i></ng-template>
        </span>
        <span class="meta">
          <span class="name">{{ c.coach?.name || 'Matching…' }}</span>
          <span class="line">{{ c.product_line_label }}</span>
        </span>
        <span class="unread" *ngIf="c.unread_count">{{ c.unread_count }}</span>
      </button>
    </div>

    <ng-container *ngIf="active">
      <div class="messages" #messageList>
        <div class="loading-state" *ngIf="loadingThread && !thread">Loading…</div>
        <div class="empty-state" *ngIf="thread && !thread.messages.length">
          Say hello to {{ active.coach?.first_name }}.
        </div>
        <ng-container *ngFor="let m of thread?.messages; let i = index">
          <div class="day-divider" *ngIf="i === 0 || !isSameDay(m.created_on, thread!.messages[i - 1].created_on)">
            <span>{{ m.created_on | date:'EEEE, MMM d' }}</span>
          </div>
          <div class="bubble-row" [class.outgoing]="isOutgoing(m.sender_id, m.from_user)">
            <div class="bubble">
              <div class="content">{{ m.content }}</div>
              <div class="meta">{{ m.created_on | date:'shortTime' }}</div>
            </div>
          </div>
        </ng-container>
      </div>

      <form class="composer" (ngSubmit)="send()">
        <textarea name="draft" rows="1" placeholder="Write a message…" aria-label="Message"
          [(ngModel)]="draft" (keydown)="onKeydown($event)" [disabled]="sending" maxlength="4000"></textarea>
        <button type="submit" class="send-btn" [disabled]="!draft.trim() || sending" aria-label="Send">
          <i class="bi bi-send-fill"></i>
        </button>
      </form>
    </ng-container>
  </div>

  <div class="coach-backdrop" *ngIf="isMobile && open" (click)="close()" aria-hidden="true"></div>
</ng-container>
